export const ORBIT_API_PREFIX = '/labs/orbit'
export const VERSION_ONE_API_PREFIX = '/v1/labs/orbit'
export const VERSION_TWO_API_PREFIX = '/v2/labs/orbit'
export const UNLIMIT = 9999

// temp fix before confirmation of role options
export const CUSTOMER_ROLE_OPTIONS = ['owner', 'admin']
export const OPS_ROLE_OPTIONS = ['opsowner', 'ops', 'opsviewer']
